import React from 'react';
import { ErrorIcon, SuccessTick, ToastMessage } from 'components/Toast/styles';

type ToastProps = {
  message: string;
}

export function SuccessToast(props: ToastProps) {
  const { message } = props;
  return (
    <ToastMessage data-automation="success-toast">
      <SuccessTick style={{ height: '20px' }} />
      {message}
    </ToastMessage>
  );
}

export function ErrorToast(props: ToastProps) {
  const { message } = props;
  return (
    <ToastMessage data-automation="error-toast">
      <ErrorIcon />
      {message}
    </ToastMessage>
  );
}

export function WarningToast(props: ToastProps) {
  const { message } = props;
  return (
    <ToastMessage data-automation="warning-toast">
      <ErrorIcon />
      {message}
    </ToastMessage>
  );
}
